export const DroppableTypes = {
  ISSUE_ATTRIBUTE_LIST_ITEM: 'ISSUE_ATTRIBUTE_LIST_ITEM'
};
